import { TRootState } from "../../types"

export const getAdminSelector = (state: TRootState) => state.admin
